webpackJsonp([109731301426160],{

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/assets/css/loading-screen.css'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The is the CSS file that captures the behavior for the loading screen.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'css', text: '\n      @-webkit-keyframes logo-breathe {\n        from {\n          opacity: .2;\n          filter: alpha(opacity=20)\n        }\n        to {\n          opacity: 1;\n          filter: alpha(opacity=100)\n        }\n      }\n\n      @keyframes logo-breathe {\n        from {\n          opacity: .2;\n          filter: alpha(opacity=20)\n        }\n        to {\n          opacity: 1;\n          filter: alpha(opacity=100)\n        }\n      }\n\n      #loading-screen {\n        background: #2595FF;\n        background-image: linear-gradient(rgba(108, 91, 123, 0.8), rgba(53, 92, 125, 0.8));\n        /*background-image: radial-gradient(rgba(108, 91, 123, 0.8), rgba(53, 92, 125, 0.8));*/\n        position: fixed;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        z-index: 999999;\n        opacity: 1;\n        transition: opacity 0.75s ease;\n      }\n\n      #loading-screen.loading-screen-fade {\n        opacity: 0;\n      }\n\n      #loading-screen.loading-screen-hide {\n        display: none;\n      }\n\n      #loading-screen .logo {\n        position: absolute;\n        background-image: url(../images/logo.png);\n        height: 150px;\n        width: 150px;\n        background-size: 150px 150px;\n        top: calc(50% - 75px);\n        left: calc(50% - 75px);\n      }\n\n      #loading-screen .logo.breathe {\n        animation-name: logo-breathe;\n        animation-duration: 1.8s;\n        animation-delay: .2s;\n        animation-timing-function: cubic-bezier(.73,.005,.42,1.005);\n        animation-iteration-count: infinite;\n        animation-direction: alternate;\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-assets-css-loading-screen-js-24583c60f9188ee1f053.js